// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader_SN79y","title":"title_AyEpc"};